module.exports = require("@material-ui/icons/Settings");